
































import { FormMessage } from '@/types/Form.interface'
import Message from '@/types/Message.interface'
import { randomKey } from '@/utility/helpers'
import Vue from 'vue'
export default Vue.extend({
    props: {
        // Determines if the save/send button is shown
        button: {
            type: Boolean,
            required: false,
            default: true
        },
        // The messages to edit (only ever response and send messages from form)
        messages: {
            type: Array,
            required: true
        }
    },
    data: () => ({
        errorList: {},
        //  Our message keys
        messageKeys: [randomKey(), randomKey()],
        //  Determines if we have finished all of our setup
        mounted: false,
        //  Contains the text and media for each message
        temp: {}
    }),
    mounted() {
        //  Set our temp to have both messages
        this.cloneMessages()

        //  We are finished mounting
        this.mounted = true
    },
    computed: {
        operator(): boolean {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is an operator
            return window.getProps(role, ['name']) === 'Operator'
        }
    },
    methods: {
        cloneMessages() {
            //  Iterate and clone each message
            this.messages.forEach((x: FormMessage) => {
                //  Grab the message attribute
                const attr = x.attribute

                //  The property will be named for the attribute
                this.temp[attr] = {
                    text: x.text,
                    media: x.media
                }
            })
        },
        //  Checks if we have made any changes to our form message passed in
        isEdited(message: FormMessage): boolean {
            //  Grab the attribute from our message
            const attr = message.attribute

            //  Grab the message at this attribute from temp
            const tempMessage = this.temp[attr]

            //  Our message has been edited if the message text OR media is different
            return !window._.isEqual(message, tempMessage)
        },
        popHelp(text: string): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Help',
                text: text,
                icon: 'mdi-help-circle',
                color: 'primary'
            })
        },
        async submit(formMsg: FormMessage, i: number, obj: Message): Promise<void> {
            //  Create our message
            const msg: FormMessage = {
                attribute: formMsg.attribute,
                text: obj.text,
                media: obj.media
            }

            //  Check if our message has changed
            const edited = this.isEdited(msg)

            //  Display error based on if it was edited or not
            this.errorList[i] = !edited

            //  This allows the DOM to update
            this.errorList = { ...this.errorList }

            //  Tell the parent that we have updated the message
            this.$emit('updateMessage', msg)
        }
    },
    watch: {
        messages: {
            deep: true,
            handler() {
                //  Clone our new messages
                this.cloneMessages()

                //  Reset our keys
                this.messageKeys[0] = randomKey()
                this.messageKeys[1] = randomKey()
            }
        }
    }
})
